import * as React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, makeStyles, TextField, Box, MenuItem } from '@material-ui/core'

import { DropzoneComponent } from 'react-dropzone-component'
import Dropzone from 'dropzone'
import 'dropzone/dist/min/dropzone.min.css'
import 'react-dropzone-component/styles/filepicker.css'
// import { host } from '../api'


const useStyles = makeStyles({
    uploadView: {
        width: 400
    }
})

type UploadDialogProps = {
    title: string,
    onSave: (filePath: string) => void,
    onClose: () => void,
    open: boolean,
}

const UploadDialog = function ({ onClose, open, title, onSave }: UploadDialogProps) {

    const classes = useStyles()
    const [filePath, setFilePath] = React.useState('')
    const uploadConfig = {
        iconFiletypes: ['.xlx', '.xlxs', '.xlxm'],
        showFiletypeIcon: true,
        postUrl: '/api/upload'
    }

    const handleImport = () =>{
        onSave(filePath)
    }
    const eventHandlers = {
        success: (file: Dropzone.DropzoneFile, response: string | Object) => {
            setFilePath(response as string)
        }
    }

    return (
        <div>
            <Dialog onClose={onClose} open={open}>
                <DialogTitle >
                    {title}
                </DialogTitle>

                <DialogContent>
                    <DropzoneComponent config={uploadConfig} djsConfig={{ maxFilesize: 4096, timeout: 20 * 60 * 1000, maxFiles: 1 }} className={classes.uploadView} eventHandlers={eventHandlers} />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleImport} disabled={!filePath}>
                        开始导入
                    </Button>
                    <Button color="primary" onClick={onClose}>
                        取消
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default UploadDialog
